module.exports = "https://deal-img.imgix.net/consumer/modern/jet-expert.97ad2ff5.jpg";